/**
 * RecordChannelReservationPage — route `/reservations/record-channel`
 * (PMS portal).
 *
 * SCRUM-350 (manual channel-ingest UI). The sanctioned SEPARATE surface
 * to the local "New reservation" form: it records a LIVE, non-integrated
 * channel booking (a real OTA booking that did NOT arrive via the channel
 * — failed sync / channel-account change) through the ALREADY-SHIPPED
 * ingest path (`POST /organizations/{slug}/reservations/ingest`; FSM /
 * snapshot UNCHANGED).
 *
 * The page body is thin: it composes the slice-internal
 * `RecordChannelReservationForm` feature and renders it. All state,
 * workflows, data-fetching, overlap pre-submit blocking, the four
 * ingest outcomes, and navigation live inside the feature.
 *
 * No self-mounted `<main>` (SCRUM-352 fixed nested-`<main>` a11y debt —
 * the PMS shell owns the sole landmark; the form renders none) and no
 * self-mounted IntlProvider (the app root supplies it). Mirrors
 * `CreateReservationPage`.
 */

import * as React from 'react';
import { RecordChannelReservationForm } from '../features/RecordChannelReservationForm.js';

export function RecordChannelReservationPage(): React.ReactElement {
  return <RecordChannelReservationForm />;
}
